export default function Surveys() {
  return <div>Surveys</div>
}
